/**
 * =============================================================================
 *  GATEKEEPER VOLUME DEALS — Cart Progress Bar & Checkout Discount
 *  Retail: 3 for $198 NZD | 5 for $297 NZD
 *  Night Market ($60 bottles): 3 for $150 NZD ($10 off each bottle at 3+)
 *
 *  HOW IT WORKS:
 *    1. Reads the cart via Shopify's /cart.js API
 *    2. Splits items into retail perfumes and night-market ($60) perfumes
 *    3. Shows the matching deal progress bar:
 *         - retail-only cart  -> 3 for $198 / 5 for $297
 *         - market-only cart  -> 3 for $150
 *         - mixed cart        -> widget hidden (Shopify applies the best
 *           single discount at checkout; no promise we can't keep)
 *    4. The checkout button preview is only rewritten when we know the exact
 *       discount Shopify will apply.
 *
 *  All real discounting is done by Shopify AUTOMATIC discounts:
 *    - "Bundle & Save · 3 for $198" / "· 5 for $297" (scoped to Shop All)
 *    - "Night Market Bundle — 3 for $150" (scoped to the night-market collection)
 * =============================================================================
 */

(function (win, doc) {
  'use strict';

  /* =========================================================================
   * ★ MERCHANT CONFIG — edit this section to manage the deal
   * ========================================================================= */

  var GK_VOL = {

    excludedHandles: [
      'build-your-luxury-bundle',
    ],

    tiers: [
      { qty: 3, totalNZD: 198, saveNZD: 27, label: '3 for $198' },
      { qty: 5, totalNZD: 297, saveNZD: 78, label: '5 for $297' },
    ],

    /* Night-market ($60) products are identified by unit price. They get their
     * own deal display matching the "Night Market Bundle — 3 for $150"
     * automatic discount: $10 off each bottle once the cart has 3+. */
    nightMarket: {
      priceCents: 6000,
      minQty: 3,
      perItemSaveNZD: 10,
      label: '3 for $150',
    },

    /* Bundle saving is applied by Shopify AUTOMATIC discounts (no code needed). */
    discountCodes: {},

    clearCode: 'GKCLEAR',
  };

  function isExcluded(item) {
    var isFreeGift = item.properties && item.properties['_free_gift'] === '1';
    return isFreeGift || GK_VOL.excludedHandles.indexOf(item.handle) !== -1;
  }

  function isNightMarketItem(item) {
    var unit = typeof item.original_price === 'number' ? item.original_price : item.price;
    return unit === GK_VOL.nightMarket.priceCents;
  }

  function splitCart(items) {
    var retailQty = 0;
    var marketQty = 0;
    items.forEach(function (item) {
      if (isExcluded(item)) return;
      if (isNightMarketItem(item)) {
        marketQty += item.quantity;
      } else {
        retailQty += item.quantity;
      }
    });
    return { retailQty: retailQty, marketQty: marketQty };
  }

  function getActiveTier(qty) {
    var active = null;
    GK_VOL.tiers.forEach(function (t) { if (qty >= t.qty) active = t; });
    return active;
  }

  function getNextTier(qty) {
    for (var i = 0; i < GK_VOL.tiers.length; i++) {
      if (qty < GK_VOL.tiers[i].qty) return GK_VOL.tiers[i];
    }
    return null;
  }

  function getProgressPct(qty) {
    var maxQty = GK_VOL.tiers[GK_VOL.tiers.length - 1].qty;
    return Math.min(100, Math.round((qty / maxQty) * 100));
  }

  function getDiscountCode(qty) {
    var code = null;
    Object.keys(GK_VOL.discountCodes).forEach(function (threshold) {
      if (qty >= parseInt(threshold, 10)) code = GK_VOL.discountCodes[threshold];
    });
    return code;
  }

  var WIDGET_ID_PAGE   = 'gk-vol-widget';
  var WIDGET_ID_DRAWER = 'gk-vol-widget-drawer';

  var _cartTotal = 0;
  /* Last computed cart state: { mode: 'retail'|'market'|'none', qty, saveNZD } */
  var _lastState = { mode: 'none', qty: 0, saveNZD: 0 };

  var GK_APPLIED_KEY = 'gk_applied_discount';

  function buildWidget(customId, mode) {
    var widgetId = customId || WIDGET_ID_PAGE;
    var badgesHTML, milestonesHTML;

    if (mode === 'market') {
      var nm = GK_VOL.nightMarket;
      badgesHTML = '<span class="gk-vol-badge" data-gk-tier="' + nm.minQty + '">' + nm.label + '</span>';
      milestonesHTML =
        '<div class="gk-vol-milestone" data-gk-tier="' + nm.minQty + '" style="left:100%">' +
          '<span class="gk-vol-milestone-label">' + nm.label + '</span>' +
        '</div>';
    } else {
      var maxQty = GK_VOL.tiers[GK_VOL.tiers.length - 1].qty;
      badgesHTML = GK_VOL.tiers.map(function (t) {
        return '<span class="gk-vol-badge" data-gk-tier="' + t.qty + '">' + t.label + '</span>';
      }).join('');
      milestonesHTML = GK_VOL.tiers.map(function (t) {
        var pct = Math.round((t.qty / maxQty) * 100);
        return '<div class="gk-vol-milestone" data-gk-tier="' + t.qty + '" style="left:' + pct + '%">' +
                 '<span class="gk-vol-milestone-label">' + t.label + '</span>' +
               '</div>';
      }).join('');
    }

    var widget = doc.createElement('div');
    widget.id = widgetId;
    widget.className = 'gk-vol-widget';
    widget.setAttribute('aria-live', 'polite');
    widget.setAttribute('data-gk-mode', mode);
    widget.innerHTML =
      '<div class="gk-vol-header">' +
        '<span class="gk-vol-icon">🎁</span>' +
        '<span class="gk-vol-title">Bundle Deal</span>' +
        '<span class="gk-vol-badges">' + badgesHTML + '</span>' +
      '</div>' +
      '<div class="gk-vol-message"></div>' +
      '<div class="gk-vol-bar-outer">' +
        '<div class="gk-vol-bar-track">' +
          '<div class="gk-vol-bar-fill" style="width:0%"></div>' +
          milestonesHTML +
        '</div>' +
      '</div>';

    return widget;
  }

  function _applyRetailState(widget, qty) {
    var activeTier = getActiveTier(qty);
    var nextTier   = getNextTier(qty);
    var pct        = getProgressPct(qty);

    var fill = widget.querySelector('.gk-vol-bar-fill');
    if (fill) fill.style.width = pct + '%';

    widget.querySelectorAll('.gk-vol-milestone').forEach(function (dot) {
      var tierQty = parseInt(dot.getAttribute('data-gk-tier'), 10);
      dot.classList.toggle('gk-vol-milestone--unlocked', qty >= tierQty);
    });

    widget.querySelectorAll('.gk-vol-badge').forEach(function (badge) {
      var tierQty = parseInt(badge.getAttribute('data-gk-tier'), 10);
      badge.classList.toggle('gk-vol-badge--active', qty >= tierQty);
    });

    var msg = widget.querySelector('.gk-vol-message');
    if (msg) {
      if (!nextTier && activeTier) {
        msg.innerHTML = '🎉 <strong>' + activeTier.label + ' NZD</strong> unlocked — you\'re saving <strong>$' + activeTier.saveNZD + ' NZD</strong>!' +
          '<br><span class="gk-vol-checkout-note">Your total will be <strong>$' + activeTier.totalNZD + ' NZD</strong> — discount applied automatically at checkout.</span>';
        widget.classList.add('gk-vol-widget--unlocked');
      } else if (activeTier && nextTier) {
        var need = nextTier.qty - qty;
        msg.innerHTML = '✅ <strong>' + activeTier.label + ' NZD</strong> deal unlocked! ' +
          'Add <strong>' + need + ' more</strong> to get <strong>' + nextTier.label + ' NZD</strong> and save <strong>$' + nextTier.saveNZD + ' NZD</strong>' +
          '<br><span class="gk-vol-checkout-note">Discount applied automatically at checkout.</span>';
        widget.classList.add('gk-vol-widget--unlocked');
      } else if (nextTier) {
        var need2 = nextTier.qty - qty;
        var plural = need2 === 1 ? 'perfume' : 'perfumes';
        msg.innerHTML = 'Add <strong>' + need2 + ' more ' + plural + '</strong> to unlock <strong>' + nextTier.label + ' NZD</strong> and save <strong>$' + nextTier.saveNZD + ' NZD</strong>!';
        widget.classList.remove('gk-vol-widget--unlocked');
      }
    }

    widget.setAttribute('data-gk-qty', qty);
  }

  function _applyMarketState(widget, qty) {
    var nm  = GK_VOL.nightMarket;
    var pct = Math.min(100, Math.round((qty / nm.minQty) * 100));

    var fill = widget.querySelector('.gk-vol-bar-fill');
    if (fill) fill.style.width = pct + '%';

    widget.querySelectorAll('.gk-vol-milestone').forEach(function (dot) {
      dot.classList.toggle('gk-vol-milestone--unlocked', qty >= nm.minQty);
    });
    widget.querySelectorAll('.gk-vol-badge').forEach(function (badge) {
      badge.classList.toggle('gk-vol-badge--active', qty >= nm.minQty);
    });

    var msg = widget.querySelector('.gk-vol-message');
    if (msg) {
      if (qty >= nm.minQty) {
        var save  = qty * nm.perItemSaveNZD;
        var total = (_cartTotal - save).toFixed(2).replace(/\.00$/, '');
        msg.innerHTML = '🎉 <strong>Night Market deal unlocked</strong> — every bottle drops to <strong>$50 NZD</strong>, you\'re saving <strong>$' + save + ' NZD</strong>!' +
          '<br><span class="gk-vol-checkout-note">Your total will be <strong>$' + total + ' NZD</strong> — discount applied automatically at checkout.</span>';
        widget.classList.add('gk-vol-widget--unlocked');
      } else {
        var need = nm.minQty - qty;
        var plural = need === 1 ? 'perfume' : 'perfumes';
        msg.innerHTML = 'Add <strong>' + need + ' more ' + plural + '</strong> to unlock <strong>' + nm.label + ' NZD</strong>!';
        widget.classList.remove('gk-vol-widget--unlocked');
      }
    }

    widget.setAttribute('data-gk-qty', qty);
  }

  function _applyWidgetState(widget, state) {
    if (state.mode === 'market') {
      _applyMarketState(widget, state.qty);
    } else {
      _applyRetailState(widget, state.qty);
    }
  }

  function removeWidgets() {
    doc.querySelectorAll('.gk-vol-widget').forEach(function (w) {
      if (w.parentElement) w.parentElement.removeChild(w);
    });
  }

  function updateWidget(state) {
    doc.querySelectorAll('.gk-vol-widget').forEach(function (w) {
      _applyWidgetState(w, state);
    });
    updateCheckoutButtonPrice(state);
  }

  function updateCheckoutButtonPrice(state) {
    doc.querySelectorAll('.checkout-button').forEach(function (btn) {
      if (!btn._gkOrigHTML) btn._gkOrigHTML = btn.innerHTML;

      if (state.saveNZD > 0 && _cartTotal > 0) {
        var discountedTotal = (_cartTotal - state.saveNZD).toFixed(2);
        btn.innerHTML = btn._gkOrigHTML.replace(
          /\$[\s]?[\d,]+\.?\d*[\s]?NZD/gi,
          '$' + discountedTotal + ' NZD'
        );
      } else {
        btn.innerHTML = btn._gkOrigHTML;
        btn._gkOrigHTML = null;
      }
    });
  }

  function injectPageWidget(mode) {
    if (doc.getElementById(WIDGET_ID_PAGE)) return;

    var target = doc.querySelector('.thb-cart-form--cart-collaterals');

    if (!target) {
      var forms = doc.querySelectorAll('form[action="/cart"]');
      forms.forEach(function (f) {
        if (!target && !f.closest('.cart-drawer') && !f.closest('.side-panel')) {
          target = f;
        }
      });
    }

    if (!target) return;
    target.insertBefore(buildWidget(WIDGET_ID_PAGE, mode), target.firstChild);
  }

  function injectDrawerWidget(mode) {
    if (doc.getElementById(WIDGET_ID_DRAWER)) return;

    var drawer = doc.querySelector('.side-panel.cart-drawer, .cart-drawer');
    if (!drawer) return;

    var target = drawer.querySelector('form[action="/cart"]') ||
                 drawer.querySelector('.cart-drawer-buttons') ||
                 drawer.querySelector('.cart-drawer-footer');
    if (!target) return;

    target.insertBefore(buildWidget(WIDGET_ID_DRAWER, mode), target.firstChild);
  }

  function injectWidget(mode) {
    /* Rebuild widgets whose mode no longer matches the cart contents. */
    doc.querySelectorAll('.gk-vol-widget').forEach(function (w) {
      if (w.getAttribute('data-gk-mode') !== mode && w.parentElement) {
        w.parentElement.removeChild(w);
      }
    });
    injectPageWidget(mode);
    injectDrawerWidget(mode);
  }

  function patchCheckoutButtons() {
    if (doc._gkCheckoutPatched) return;
    doc._gkCheckoutPatched = true;

    doc.addEventListener('click', function (e) {
      var el = e.target;
      var isCheckoutBtn = false;
      while (el && el !== doc.body) {
        if (
          (el.classList && el.classList.contains('checkout-button')) ||
          (el.tagName === 'A' && el.getAttribute('href') === '/checkout')
        ) {
          isCheckoutBtn = true;
          break;
        }
        el = el.parentElement;
      }
      if (!isCheckoutBtn) return;

      var widget = doc.getElementById(WIDGET_ID_PAGE) || doc.getElementById(WIDGET_ID_DRAWER);
      var qty = widget ? parseInt(widget.getAttribute('data-gk-qty') || '0', 10) : 0;
      var code = getDiscountCode(qty);

      if (code) {
        e.preventDefault();
        e.stopImmediatePropagation();
        try { localStorage.setItem(GK_APPLIED_KEY, code); } catch (err) {}
        win.location.href = '/discount/' + code + '?redirect=%2Fcheckout';
      }
    }, true);
  }

  function refresh() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
      if (xhr.status !== 200) return;
      try {
        var cart  = JSON.parse(xhr.responseText);
        var split = splitCart(cart.items);

        _cartTotal = (cart.original_total_price || cart.total_price) / 100;

        var state;
        if (split.marketQty > 0 && split.retailQty === 0) {
          var nm = GK_VOL.nightMarket;
          state = {
            mode: 'market',
            qty: split.marketQty,
            saveNZD: split.marketQty >= nm.minQty ? split.marketQty * nm.perItemSaveNZD : 0,
          };
        } else if (split.retailQty > 0 && split.marketQty === 0) {
          var tier = getActiveTier(split.retailQty);
          state = {
            mode: 'retail',
            qty: split.retailQty,
            saveNZD: tier ? tier.saveNZD : 0,
          };
        } else {
          /* Mixed retail + night-market cart (or empty): Shopify applies the
           * single best discount at checkout — hide the widget rather than
           * promise a number we can't guarantee. */
          state = { mode: 'none', qty: 0, saveNZD: 0 };
        }
        _lastState = state;

        try {
          var appliedCode = localStorage.getItem(GK_APPLIED_KEY);
          if (appliedCode) {
            var stillValid = state.mode === 'retail' && getDiscountCode(state.qty) === appliedCode;
            if (!stillValid) {
              localStorage.removeItem(GK_APPLIED_KEY);
              var returnPath = encodeURIComponent(win.location.pathname + win.location.search);
              win.location.href = '/discount/' + GK_VOL.clearCode + '?redirect=' + returnPath;
              return;
            }
          }
        } catch (storageErr) {}

        if (state.mode === 'none') {
          removeWidgets();
          updateCheckoutButtonPrice(state);
        } else {
          injectWidget(state.mode);
          updateWidget(state);
        }
        patchCheckoutButtons();
      } catch (err) {
      }
    };
    xhr.send();
  }

  function watchCartChanges() {
    if (typeof win.fetch === 'function' && !win._gkFetchPatched) {
      win._gkFetchPatched = true;
      var _origFetch = win.fetch;
      win.fetch = function (url) {
        var result = _origFetch.apply(this, arguments);
        if (typeof url === 'string' && url.indexOf('/cart') !== -1) {
          result.then(function () { setTimeout(refresh, 500); });
        }
        return result;
      };
    }

    doc.addEventListener('change', function (e) {
      var el = e.target;
      if (el && (el.name === 'updates[]' || (el.closest && el.closest('[class*="cart"]')))) {
        setTimeout(refresh, 700);
      }
    });

    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.action && form.action.indexOf('/cart') !== -1) {
        setTimeout(refresh, 700);
      }
    });
  }

  function init() {
    refresh();
    watchCartChanges();

    if (typeof MutationObserver !== 'undefined') {
      var _drawerObserver = new MutationObserver(function () {
        var needsDrawerWidget = !doc.getElementById(WIDGET_ID_DRAWER) &&
                                 doc.querySelector('.side-panel.cart-drawer, .cart-drawer') &&
                                 _lastState.mode !== 'none';
        if (needsDrawerWidget) {
          injectDrawerWidget(_lastState.mode);
          var drawerWidget = doc.getElementById(WIDGET_ID_DRAWER);
          if (drawerWidget) {
            _applyWidgetState(drawerWidget, _lastState);
            updateCheckoutButtonPrice(_lastState);
          }
        }
      });
      _drawerObserver.observe(doc.body || doc.documentElement, {
        childList: true,
        subtree:   true,
      });
    }
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}(window, document));
